module.exports = __webpack_public_path__ + "static/media/21ECLAC32.dce444f3.jpg";